import {
  CONTENT_WIDTH,
  bottomMarginItemGlobal,
  MARGIN_LEFT
} from "../../utils/pdfConstants";

export function renderTutkimustarpeetTauluBlock({
  ptsContext,
  content = [],
  fontSize = 10,
  contentWidth = CONTENT_WIDTH,
  showAlvZero = false,
  hide11thYear = false
} = {}) {
  if (!ptsContext) throw new Error("ptsContext is required");

  const currentYear = new Date().getFullYear();

  // --- Data ---
  const tableData = ptsContext.tutkimusData || [];
  const totals = ptsContext.tutkimusYhteensa || [];
  const allYears =
    ptsContext.years || Array.from({ length: 11 }, (_, i) => currentYear + i);
  // Display-only truncation — the underlying 11-value arrays are untouched,
  // same pattern as renderTekniikkataulutBlock.js.
  const years = hide11thYear ? allYears.slice(0, 10) : allYears;

  // --- Widths ---
  const firstColWidth = 170;
  const columnWidths = [firstColWidth, ...Array(years.length).fill('*')];

  // --- Fonts ---
  const smallFontSize = fontSize * 0.85;
  const yearsFontSize = fontSize * 0.75;

  const rows = [];

  const renderCellValue = (v) => {
    // Treat 0, "0", null, undefined, and empty string as empty
    if (v === 0 || v === "0" || v === null || v === undefined || v === "") return "";
    return String(v); // convert everything else to string
  };

  // ======================================================
  // Super Header Row
  // ======================================================
  rows.push([
    {
      text:
        "Kustannusarvio (x 1000€) " +
        (showAlvZero
          ? `Kustannustaso ${currentYear} ALV 0%`
          : `Kustannustaso ${currentYear} sis. Alv 25,5%`),
      colSpan: years.length + 1,
      alignment: "right",
      bold: true,
      font: "Lato",
      fontSize: smallFontSize,
      color: "white",
      fillColor: "#04aa00",
      margin: [0, 2, 4, 2],
    },
    ...Array(years.length).fill({})
  ]);

  // ======================================================
  // Header Row (Title + Years)
  // ======================================================
  rows.push([
    {
      text: "Tutkimustarpeet",
      bold: true,
      alignment: "left",
      font: "Lato",
      fontSize: smallFontSize,
      fillColor: "#04aa00",
      color: "white",
      noWrap: true
    },
    ...years.map(y => ({
      text: String(y),
      alignment: "center",
      bold: true,
      font: "Lato",
      fontSize: yearsFontSize,
      fillColor: "#04aa00",
      color: "white",
      noWrap: true
    }))
  ]);

  // ======================================================
  // Body Rows (ONLY Item Labels)
  // ======================================================
  tableData.forEach(section => {
    section.items.forEach(item => {
      const label = (item.label || "").trim();
      if (label.length < 2) return;

      rows.push([
        {
          text: label,
          alignment: "left",
          font: "Lato",
          fontSize: smallFontSize,
          margin: [2, 2, 0, 2],
          noWrap: false
        },
        ...item.values.slice(0, years.length).map(v => ({
          text: v === 0 || v === null || v === undefined || v === "" || v === '0' ? "" : String(v),
          alignment: "center",
          font: "Lato",
          fontSize: smallFontSize,
          margin: [0, 2, 0, 2],
        }))
      ]);
    });
  });

  // ======================================================
  // Totals Row
  // ======================================================
  rows.push([
    {
      text: "YHTEENSÄ",
      bold: true,
      alignment: "left",
      font: "Lato",
      fontSize: smallFontSize,
      fillColor: "#04aa00",
      color: "white",
      noWrap: true
    },
    ...totals.slice(0, years.length).map(sum => ({
      text: sum === 0 ? "" : String(sum),
      alignment: "center",
      bold: true,
      font: "Lato",
      fontSize: smallFontSize,
      fillColor: "#04aa00",
      color: "white",
      noWrap: true
    }))
  ]);

  // ======================================================
  // Push Table
  // ======================================================
  content.push({
    table: {
      headerRows: 2,
      widths: columnWidths,
      body: rows
    },

    layout: {
      // Draw horizontal lines only between item rows
      hLineWidth: (i, node) => {
        const lastItemRow = node.table.body.length - 2; // last item row before totals
        return i > 1 && i <= lastItemRow ? 0.5 : 0;
      },
      vLineWidth: () => 0,
      hLineColor: () => "#bbb",
      vLineColor: () => "#bbb",
      paddingLeft: () => 4,
      paddingRight: () => 4,
      paddingTop: () => 4,
      paddingBottom: () => 4
    },

    dontBreakRows: true,
    margin: [0, bottomMarginItemGlobal, 0, 0]
  });
}
